import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

const Candidates = Loadable({
  loader: () => import('./containers/CandidatesContainer'),
  loading: Loading,
})

export default {
  path: '/reports',
  exact: true,
  component: Candidates
}



// WEBPACK FOOTER //
// ./src/routes/candidates/index.js